import { toast } from "react-toastify"
import { createBanner, deleteBanner, editBanner } from "./bannerService"
import { bannerStoreMethods } from "../stores/bannersStore"

const create = (variables, backgroundImage, useRanksystem, ranksystemConfig) => {
    let toastId = null

    function onProgress(p) {
        const progress = p.loaded / p.total
        const percent = Math.floor(progress * 100)

        if (toastId === null) {
            toastId = toast("در حال اپلود  بک گراند " + `${percent}%`, { progress })
        } else {
            toast.update(toastId, { progress, render: `درحال اپلود بک گراند ${percent}%` })
        }
    }

    const formData = new FormData()
    formData.append("backgroundImage", backgroundImage)
    formData.append("variables", JSON.stringify(variables))
    formData.append("useRanksystem", useRanksystem)
    formData.append("ranksystemConfig", JSON.stringify(ranksystemConfig))

    createBanner(formData, onProgress)
        .then(({ data }) => {
            bannerStoreMethods.addBanner(data)

            toast.done(toastId)
            toast.dismiss(toastId)
            toast.success("با موفقیت ذخیره شد")
        })
        .catch((err) => {
            console.error(err)
        })
}

const edit = (bannerId, variables, backgroundImage, useRanksystem, ranksystemConfig) => {
    let toastId = null

    function onProgress(p) {
        const progress = p.loaded / p.total
        const percent = Math.floor(progress * 100)

        if (toastId === null) {
            toastId = toast("در حال اپلود  بک گراند " + `${percent}%`, { progress })
        } else {
            toast.update(toastId, { progress, render: `درحال اپلود بک گراند ${percent}%` })
        }
    }

    const formData = new FormData()

    formData.append("bannerId", bannerId)

    if (backgroundImage) {
        formData.append("backgroundImage", backgroundImage)
    }
    formData.append("variables", JSON.stringify(variables))
    formData.append("ranksystemConfig", JSON.stringify(ranksystemConfig))
    formData.append("useRanksystem", useRanksystem)

    editBanner(formData, onProgress).then(({ data }) => {
        bannerStoreMethods.updateBanner(data)

        toast.done(toastId)
        toast.dismiss(toastId)
        toast.success("با موفقیت ذخیره شد")
    })
}

const delBanner = (bannerId) => {
    toast
        .promise(deleteBanner({ bannerId }), {
            pending: "درحال حذف",
            success: "بنر با موفقیت حذف شد",
        })
        .then((res) => {
            bannerStoreMethods.deleteBanner(bannerId)
        })
}

export default { create, edit, delBanner }
